module.exports = __webpack_public_path__ + "files/57071636728ecdcf5e46cb6ff391ebd1.png";